import { render, staticRenderFns } from "./data35.vue?vue&type=template&id=1d774740&scoped=true"
import script from "./data35.vue?vue&type=script&lang=js"
export * from "./data35.vue?vue&type=script&lang=js"
import style1 from "./data35.vue?vue&type=style&index=1&id=1d774740&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d774740",
  null
  
)

export default component.exports